import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  groupDataCurrentCount: 0,
  groupDataCount: 0,
  seekPosition: 0,
  totalSeekPosition: 0,
  timeMachineDataAvailable: false,
  currentPageTimeMachineData: {
    pageSize: 0,
    data: ["startData"]
  },
  timeMachineControllerIsOpen: true,
  timeMachineModeIsEnabled: false,
  timeMachineState: true,
  timeMachineLoader: true,
  isTimeMachineDataAvailable: false,
  currentPageCount: null,
  timeMachineDataFetchComplete:false
};

const oldTimeMachineSlice = createSlice({
  name: "oldTimeMachine",
  initialState,
  reducers: {
    setGroupDataCurrentCount: (state, action) => {
      state.groupDataCurrentCount = action.payload;
    },
    setGroupDataCount: (state, action) => {
      state.groupDataCount = action.payload;
    },
    setSeekPosition: (state, action) => {
      state.seekPosition = action.payload;
    },
    setTotalSeekPosition: (state, action) => {
      state.totalSeekPosition = action.payload;
    },
    setTimeMachineDataAvailable: (state, action) => {
      state.timeMachineDataAvailable = action.payload;
    },
    setCurrentPageTimeMachineData: (state, action) => {
      state.currentPageTimeMachineData = action.payload;
    },
    setTimeMachineControllerIsOpen: (state, action) => {
      state.timeMachineControllerIsOpen = action.payload;
    },
    setTimeMachineModeIsEnabled: (state, action) => {
      state.timeMachineModeIsEnabled = action.payload;
    },
    setTimeMachineState: (state, action) => {
      state.timeMachineState = action.payload;
    },
    setTimeMachineLoader: (state, action) => {
      state.timeMachineLoader = action.payload;
    },
    setIsTimeMachineDataAvailable: (state, action) => {
      state.isTimeMachineDataAvailable = action.payload;
    },
    setCurrentPageCount: (state, action) => {
      state.currentPageCount = action.payload;
    },
    setTimeMachineDataFetchComplete: (state, action) => {
      state.timeMachineDataFetchComplete= action.payload
    }
  }
});

export const {
  setGroupDataCurrentCount,
  setGroupDataCount,
  setSeekPosition,
  setTotalSeekPosition,
  setTimeMachineDataAvailable,
  setCurrentPageTimeMachineData,
  setTimeMachineControllerIsOpen,
  setTimeMachineModeIsEnabled,
  setTimeMachineState,
  setTimeMachineLoader,
  setIsTimeMachineDataAvailable,
  setCurrentPageCount,
  setTimeMachineDataFetchComplete
} = oldTimeMachineSlice.actions;

export default oldTimeMachineSlice.reducer;
